export enum NovaErrorCode {
  UnverifiedEmail = 'unverified-email',
  UserNotFound = 'user-not-found',
  UserAccountBlocked = 'user-account-blocked',
  PasswordLoginForbidden = 'password-login-forbidden',
  InternalLoginForbidden = 'internal-login-forbidden',
  ReferenceNumberValidationFailure = 'reference-number-validation-failure'
}
